import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { adminStripeBillingQueryKey } from "@/admin/data/useAdminStripeBilling";
import api from "@/common/utils/api";
import { AdminStripeBillingDetails } from "@reflag/shared/adminAPI";
import { ErrorResponse } from "@reflag/shared/api";

export function useAdminStripeBillingSyncMutation(orgId: string) {
  const queryClient = useQueryClient();

  return useMutation<
    AdminStripeBillingDetails,
    AxiosError<ErrorResponse>,
    void,
    void
  >({
    mutationKey: ["admin", "org", orgId, "stripe-billing", "sync"],
    mutationFn: () =>
      api
        .post<"/admin/:orgId/stripe-billing/sync">(
          `/admin/${orgId}/stripe-billing/sync`,
          {},
        )
        .then((res) => res.data),
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: adminStripeBillingQueryKey(orgId),
      });
    },
  });
}
